export const isUserLoggedIn = () => {
  if (
    JSON.parse(localStorage.getItem("user")) === null &&
    JSON.parse(localStorage.getItem("claims")) === null
  ) {
    return false;
  }
  return true;
};
